import { SYSTEM } from "@thi.ng/random/system";
const DEFAULT_OPTS = {
  bins: 2,
  scale: 1,
  rnd: SYSTEM
};
export {
  DEFAULT_OPTS
};
